export default __webpack_public_path__ + "5d18d2e2d6275b2349c02ae304a9d18f.png";